import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceBase, OrigamiHttpResponse } from './base/service.base';

export namespace ActionManagementServiceOptions {
  export interface Action {
    ActionId: number;
    ActionName: string;
    DisplayName: string;
    Groups: any[];
    UserActionExists: boolean;
    Modules: ModuleItem[];
  }

  export interface ModuleItem {
    Default: boolean;
    ModuleName: string;
  }

  export interface GetSiteActions {
    siteId: number;
  }
}

@Injectable()
export class ActionManagementService extends ServiceBase {
  serviceUrl = 'ActionManagementService.svc';

  public getSiteActions(
    body: ActionManagementServiceOptions.GetSiteActions,
    forceRequest?: boolean,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/GetSiteActions', body, null, null, forceRequest);
  }
}
